import { Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center p-6">
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <CardTitle className="text-2xl text-center">48th House & Condo Expo Bangkok</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-6 rounded-lg border text-center space-y-3">
              <h2 className="font-semibold">Register ลงทะเบียน</h2>
              <p className="text-sm text-muted-foreground">Sign up to attend the expo</p>
              <Button className="w-full" onClick={() => navigate("/register")}>
                Start Registration
              </Button>
            </div>
            <div className="p-6 rounded-lg border text-center space-y-3">
              <h2 className="font-semibold">Look up ค้นหา</h2>
              <p className="text-sm text-muted-foreground">Retrieve your registration and QR</p>
              <Button variant="outline" className="w-full" onClick={() => navigate("/lookup")}>
                Find My QR
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
